<template>
    <span>
        <template v-if="productsToDisplay.length === 1">
            du lot
            <v-chip color="app-green" class="ma-0 pa-1" small label dark>{{ productsToDisplay[0].reference }}</v-chip>
        </template>
        <template v-else>
            des lots
            <template v-for="(product, i) of productsToDisplay">
                <v-chip :key="product.id" color="app-green" class="ma-0 pa-1"
                     small label dark>{{ product.reference }}</v-chip>
                    <span v-if="i < productsToDisplay.length - 2" :key="product.id + '_comma_' + i" class="mr-2">,</span>
                    <span v-if="i === productsToDisplay.length - 2" :key="product.id + '_and'" class="mr-2 ml-2">et</span>
            </template>
        </template>
    </span>
</template>

<script>

export default {
    name: 'ProductsDisplayChips',

    props: {
        products: { type: Array, required: true }
    },

    computed: {
        productsToDisplay() {
            if (this.mainProducts.length === 0) {
                return this.secondaryProducts;
            } else {
                return this.mainProducts;
            }
        },

        mainProducts() {
            return this.products.filter(p => p.main === 1);
        },

        secondaryProducts() {
            return this.products.filter(p => p.main !== 1);
        }
    }
};
</script>